<script setup>
import ArrowSquareOutIcon from '@iconify-vue/ph/arrow-square-out';
import { Link } from '@inertiajs/vue3';
import BaseCell from '@js/components/tables/cells/BaseCell.vue';

const {
    rating,
    total,
    color,
    href = null,
    inertia = false,
    target = '_blank',
} = defineProps({
    rating: {
        type: Number,
        required: true,
    },
    total: {
        type: Number,
        required: true,
    },
    color: {
        type: String,
        required: false,
    },
    href: {
        type: String,
        required: false,
    },
    inertia: {
        type: Boolean,
        required: false,
    },
    target: {
        type: String,
        required: false,
    },
});
</script>

<template>
    <BaseCell>
        <component
            :is="href ? (inertia ? Link : 'a') : 'div'"
            :href="href || undefined"
            :target="href && !inertia ? target : undefined"
            class="text-lg font-bold whitespace-nowrap"
            :class="{
                'text-green-500': color === 'green',
                'text-yellow-500': color === 'yellow',
                'text-red-500': color === 'red',
                'hover:underline': href,
            }"
        >
            {{ rating }} / {{ total }}

            <sup v-if="href" class="ml-1">
                <ArrowSquareOutIcon class="inline size-3" />
            </sup>
        </component>
    </BaseCell>
</template>
